export enum EComplaintUrls {
  COMPLAINT = 'complaints',
  COMMENT = 'comment',
  ATTACHMENT = 'attachment',
  VIEW = 'view',
}
